import styled from 'styled-components'
import { Draggable as DraggableComponent } from 'ui'
import CanvasComponent from './canvas'

export const Canvas = styled(CanvasComponent)`
    display: block;
    height: 100%;
    position: relative;
    width: 100%;
`

export const Draggable = styled(DraggableComponent)`
    position: absolute;
`
